export default {
  'movementDirectSaleXFinancial.form.reportType': 'Report Type',
  'movementDirectSaleXFinancial.form.reportType.noFinancialAndDifferentValue':
    'No Financial/Different Value',
  'movementDirectSaleXFinancial.form.reportType.overview': 'Overview',

  'movementDirectSaleXFinancial.form.orderOfReport': 'Order Of Report',
  'movementDirectSaleXFinancial.form.orderOfReport.numberDirectSale': 'Nº DS',
  'movementDirectSaleXFinancial.form.orderOfReport.employee': 'Employee',
  'movementDirectSaleXFinancial.form.onlyDirectSaleWithoutFinancialRegistration':
    'Only DV without financial registration',

  'movementDirectSaleXFinancial.form.filterByDate': 'Filter by Date',
  'movementDirectSaleXFinancial.form.filterByDate.directSale': 'Direct Sale',
  'movementDirectSaleXFinancial.form.filterByDate.financial': 'Financial',

  'movementDirectSaleXFinancial.form.filterDirectSalesBy':
    'Filter Direct Sales By',
  'movementDirectSaleXFinancial.form.filterDirectSalesBy.sale': 'Sale',
  'movementDirectSaleXFinancial.form.filterDirectSalesBy.authorization':
    'Authorization',

  'movementDirectSaleXFinancial.form.filterFinancialBy': 'Filter Financial By',
  'movementDirectSaleXFinancial.form.filterFinancialBy.emission': 'Emission',
  'movementDirectSaleXFinancial.form.filterFinancialBy.dueDate': 'Due Date',
  'movementDirectSaleXFinancial.form.filterFinancialBy.receipt': 'Receipt',

  'movementDirectSaleXFinancial.form.moreOptions': 'More Options',
  'movementDirectSaleXFinancial.form.moreOptions.employee': 'Employee',
  'movementDirectSaleXFinancial.form.moreOptions.documentTypes':
    'Document Types',
};
